
export class SubscriptionType {
  id?: number;
  name?: string;
  updatableRows?: Array<string>;

  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.updatableRows = data.updatableRows;
  }
}
